// This file is auto-generated by @hey-api/openapi-ts

export type AadharVerificationDetails = {
    aadhar_number?: string;
    verification_id?: string;
};

/**
 * Error response for unauthorized access
 */
export type AccessDeniedErrorResponseContent = {
    message: string;
    error?: ErrorResponse;
};

/**
 * Address details
 */
export type Address = {
    /**
     * Unique identifier of the address
     */
    id: string;
    /**
     * Address line1
     */
    address_line1: string;
    /**
     * Address line2
     */
    address_line2?: string;
    /**
     * Country code
     */
    country_code: string;
    /**
     * State
     */
    state: string;
    /**
     * City
     */
    city: string;
    /**
     * Pincode
     */
    pin_code?: string;
};

export type AddressModel = {
    /**
     * Address line-1
     */
    address_line1?: string;
    /**
     * Address line-2
     */
    address_line2?: string;
    country_code?: CountryIsoCode;
    /**
     * State
     */
    state?: string;
    /**
     * City
     */
    city?: string;
    /**
     * Pin code
     */
    pin_code?: string;
};

export type AffiliateCommissionsData = {
    total_commission_earned?: number;
    commissions?: Array<Commission>;
};

export type AffiliateCustomersData = {
    affiliate_code?: string;
    is_premium_affiliate_manager?: boolean;
    linked_customer?: Array<LinkedCustomer>;
};

export type AffiliateUserData = {
    user_id: string;
    affiliate_code: string;
    affiliate_manager: boolean;
    is_premium_affiliate: boolean;
};

export type Amount = {
    currency?: Currency;
    value?: number;
};

export type AutoWithdrawal = 'ENABLE' | 'DISABLE';

/**
 * Base response structure for all API responses
 */
export type BadRequestErrorResponseContent = {
    message: string;
    error?: ErrorResponse;
};

export type BankAccountResponseModel = {
    indian_bank_account_list?: Array<IndianBankAccount>;
};

export type BankAccountType = 'ACH' | 'WIRE' | 'FEDWIRE' | 'RTP' | 'SWIFT' | 'SEPA_CREDIT' | 'SEPA_INSTANT' | 'FPS' | 'EFT';

export type BankDetails = {
    currency?: string;
    bank_name?: string;
    bank_address?: string;
    account_type?: string;
    domestic_credit?: string;
    domestic_debit?: string;
    domestic_fast_credit?: string;
    domestic_wire?: string;
    global_wire?: string;
    iban?: string;
    last4?: string;
    number?: string;
    type?: BankAccountType;
};

export type BeneficialOwner = {
    /**
     * Beneficial owner id
     */
    beneficial_owner_id: string;
    /**
     * Beneficial owner's name
     */
    beneficial_owner_name?: string;
    /**
     * Beneficial owner's PAN number
     */
    beneficial_owner_pan?: string;
    /**
     * PAN file ID
     */
    pan_file_id?: string;
    address?: Address;
    /**
     * Home address file ID
     */
    home_address_file_id?: string;
};

export type BusinessActivityType = 'TECHNOLOGY_SERVICES' | 'RESEARCH_AND_ANALYTICS_SERVICES' | 'MANUFACTURING' | 'GOODS_EXPORT' | 'MARKETING_AND_ADVERTISING';

export type BusinessCredibilityInformationData = {
    business_website_url?: string;
    online_presence_url?: string;
    support_documents?: Array<SupportDocument>;
    average_invoice_amount?: Money;
    average_number_of_invoices_per_month?: number;
    business_purpose?: string;
    purpose_code?: Array<PurposeCode>;
};

export type Calculations = {
    mmr_rate?: number;
    service_charge?: Amount;
    gross?: number;
    fx_spread?: FxSpread;
};

export type Commission = {
    /**
     * Commission earned date
     */
    payout_date: string;
    client: string;
    email: string;
    gross_amount: number;
    net_amount: number;
    settled_amount: number;
    commission_earned: number;
    payout_reference: string;
};

export type CompanyType = 'COMPANY' | 'LIMITED_LIABILITY_PARTNERSHIP' | 'INDIVIDUAL' | 'OTHER';

export type CompliancePackageRequestSummary = {
    request_id: string;
    request_status: RequestStatus;
    requested_at: string;
    from_time: string;
    to_time: string;
};

export type ContactFormResponseModel = {
    success: boolean;
    message: string;
};

export type CountryIsoCode = 'AD' | 'AE' | 'AG' | 'AI' | 'AL' | 'AM' | 'AO' | 'AR' | 'AT' | 'AU' | 'AW' | 'AZ' | 'BA' | 'BB' | 'BE' | 'BF' | 'BG' | 'BH' | 'BI' | 'BJ' | 'BM' | 'BN' | 'BO' | 'BR' | 'BS' | 'BW' | 'BZ' | 'CA' | 'CG' | 'CH' | 'CI' | 'CL' | 'CM' | 'CN' | 'CO' | 'CR' | 'CV' | 'CY' | 'CZ' | 'DE' | 'DJ' | 'DK' | 'DM' | 'DO' | 'DZ' | 'EC' | 'EE' | 'EG' | 'ER' | 'ES' | 'FI' | 'FJ' | 'FK' | 'FO' | 'FR' | 'GA' | 'GB' | 'GD' | 'GE' | 'GF' | 'GH' | 'GI' | 'GL' | 'GM' | 'GP' | 'GQ' | 'GR' | 'GT' | 'GU' | 'GW' | 'HK' | 'HN' | 'HR' | 'HT' | 'HU' | 'ID' | 'IE' | 'IN' | 'IL' | 'IS' | 'IT' | 'JO' | 'JP' | 'KE' | 'KG' | 'KH' | 'KI' | 'KR' | 'KW' | 'KY' | 'KZ' | 'LA' | 'LI' | 'LR' | 'LS' | 'LT' | 'LU' | 'LV' | 'MA' | 'MC' | 'MD' | 'ME' | 'MG' | 'MN' | 'MO' | 'MR' | 'MT' | 'MU' | 'MW' | 'MX' | 'MY' | 'MZ' | 'NA' | 'NE' | 'NG' | 'NL' | 'NO' | 'NZ' | 'OM' | 'PA' | 'PE' | 'PF' | 'PG' | 'PH' | 'PL' | 'PR' | 'PS' | 'PT' | 'PY' | 'QA' | 'RE' | 'RO' | 'RS' | 'SA' | 'SE' | 'SG' | 'SI' | 'SK' | 'SL' | 'SM' | 'SN' | 'SZ' | 'TD' | 'TG' | 'TH' | 'TJ' | 'TL' | 'TM' | 'TN' | 'TR' | 'TT' | 'TW' | 'TZ' | 'UG' | 'US' | 'UY' | 'VN' | 'VU' | 'ZA';

/**
 * Input for creating customer
 */
export type CreateCustomerRequestContent = {
    status?: CustomerStatus;
    country_code?: CountryIsoCode;
    customer_type?: CustomerType;
    business_registration_type?: IndiaBusinessRegistrationType;
};

/**
 * Create Customer Response
 */
export type CreateCustomerResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: CustomerModel;
};

export type CreateInvoicePreviewOutputPayload = Blob | File;

/**
 * Base request structure containing organization ID
 */
export type CreateInvoicePreviewRequestContent = {
    invoice_data: InvoiceRequestPayload;
};

/**
 * Input for creating Invoice
 */
export type CreateInvoiceRequestContent = {
    invoice_id?: string;
    invoice_data: InvoiceRequestPayload;
};

/**
 * Create Invoice Response
 */
export type CreateInvoiceResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: InvoicesModel;
};

/**
 * Input for creating or updating an NFC card
 */
export type CreateOrUpdateNfcCardRequestContent = {
    /**
     * Name on the NFC card
     */
    name: string;
    /**
     * Email associated with the NFC card
     */
    email: string;
    /**
     * Company name
     */
    company?: string;
    /**
     * Title/Designation
     */
    title?: string;
    /**
     * Mobile number
     */
    mobile?: string;
    /**
     * External Profile Id
     */
    external_profile_id?: string;
    /**
     * Design Id
     */
    design_id?: string;
};

/**
 * Success response containing NFC card data
 */
export type CreateOrUpdateNfcCardResponseContent = {
    message: string;
    error?: ErrorResponse;
    data: NfcCardModel;
};

/**
 * Input for creating partner
 */
export type CreatePartnerRequestContent = {
    /**
     * associative customer id
     */
    associative_customer_id?: string;
    /**
     * Business name
     */
    business_name?: string;
    /**
     * Address line-1
     */
    address_line1?: string;
    /**
     * Address line-2
     */
    address_line2?: string;
    country_code?: CountryIsoCode;
    /**
     * State
     */
    state?: string;
    /**
     * City
     */
    city?: string;
    /**
     * Pin code
     */
    pin_code?: string;
    /**
     * Contact person name
     */
    contact_person_name?: string;
    /**
     * Service provided
     */
    service_provided?: string;
    /**
     * Contact email
     */
    contact_email?: string;
    /**
     * Contact phone number
     */
    contact_phone_number?: string;
    /**
     * Contact person designation
     */
    contact_person_designation?: string;
    company_type?: CompanyType;
};

/**
 * Create Partner Response
 */
export type CreatePartnerResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: PartnerModel;
};

export type Currency = 'INR' | 'USD' | 'EUR' | 'GBP' | 'CAD' | 'SGD' | 'AUD' | 'AED';

export type CustomerApiCredentialOperationInputs = {
    revoke_reason?: string;
};

export type CustomerApiCredentialOperations = 'REVOKE' | 'ROTATE_SECRET';

export type CustomerApiCredentialStatus = 'ACTIVE' | 'REVOKED';

export type CustomerApiCredentialsModel = {
    api_key: string;
    organization_id: string;
    customer_id: string;
    name: string;
    status: CustomerApiCredentialStatus;
    revoke_reason?: string;
};

export type CustomerStatus = 'INACTIVE' | 'ACTIVE';

export type CustomerType = 'INDIVIDUAL' | 'BUSINESS';

/**
 * Base response structure for all API responses
 */
export type DeleteBeneficialOwnerResponseContent = {
    message: string;
    error?: ErrorResponse;
};

/**
 * Base response structure for all API responses
 */
export type DeleteFileByIdResponseContent = {
    message: string;
    error?: ErrorResponse;
};

/**
 * Base response structure for all API responses
 */
export type DeleteUserResponseContent = {
    message: string;
    error?: ErrorResponse;
};

export type DirectorDetails = {
    id?: string;
    name?: string;
    pan?: string;
    ubo?: boolean;
    senior_management?: boolean;
    is_manual?: boolean;
    update_enabled?: boolean;
    is_aadhar_verified?: boolean;
    aadhar_verification_details?: AadharVerificationDetails;
};

/**
 * Base response structure for all API responses
 */
export type DownloadCompliancePackageResponseContent = {
    message: string;
    error?: ErrorResponse;
    /**
     * Short-lived pre-signed URL
     */
    download_url: string;
};

export type ErrorResponse = {
    code: string;
    details?: string;
};

export type ExcelDataPayload = {
    /**
     * List of row data objects. Each object represents a row in the Excel file
     */
    rows: Array<ExcelRowData>;
};

export type ExcelRowData = {
    [key: string]: string;
};

export type FileResponseModel = {
    id?: string;
    name?: string;
    mime_type?: string;
    size?: number;
    url?: string;
    purpose?: Purpose;
    submitted_at?: string;
};

export type FircResponseModel = {
    id?: string;
    date?: string;
    bank_name?: string;
    purpose_code?: string;
    source_amount?: Amount;
    converted_amount?: Amount;
    conversion_rate?: number;
    service_charge?: string;
    document_id?: string;
    beneficiary_name?: string;
    calculations?: Calculations;
};

export type FxSpread = {
    paise?: number;
    bps?: number;
};

export type GenerateBankDetailsPdfOutputPayload = Blob | File;

export type GenerateBankDetailsPdfRequestContent = {
    beneficiary_name: string;
    payer_name: string;
    bank_details: Array<BankDetails>;
};

export type GenerateHdfcIrmReportOutputPayload = Blob | File;

/**
 * Base request structure containing organization ID
 */
export type GenerateHdfcIrmReportRequestContent = {
    purpose: Purpose;
    data: ExcelDataPayload;
};

export type GenerateHdfcRequestLetterOutputPayload = Blob | File;

/**
 * Base request structure containing organization ID
 */
export type GenerateHdfcRequestLetterRequestContent = {
    data: RequestLetterPayload;
};

/**
 * Base response structure for all API responses
 */
export type GetAffiliateCommissionsResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: AffiliateCommissionsData;
};

/**
 * Base response structure for all API responses
 */
export type GetAffiliateCustomersResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: AffiliateCustomersData;
};

/**
 * Base response structure for all API responses
 */
export type GetAnalyticsForPayoutsGraphResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: Array<GetAnalyticsForPayoutsGraphResponseModel>;
};

export type GetAnalyticsForPayoutsGraphResponseModel = {
    date: string;
    settled_amount: Money;
    settled_count: number;
};

/**
 * Base response structure for all API responses
 */
export type GetBankAccountByPayoutIdResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: IndianBankAccount;
};

/**
 * Base response structure for all API responses
 */
export type GetBankAccountsResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: BankAccountResponseModel;
};

/**
 * Base response structure for all API responses
 */
export type GetBeneficialOwnersResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: Array<BeneficialOwner>;
};

/**
 * Base response structure for all API responses
 */
export type GetCompliancePackageRequestsResponseContent = {
    message: string;
    error?: ErrorResponse;
    requests: Array<CompliancePackageRequestSummary>;
};

export type GetCostsFromFircInputPayload = Blob | File;

/**
 * Base response structure for all API responses
 */
export type GetCostsFromFircResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: GetCostsFromFircResponseModel;
};

export type GetCostsFromFircResponseModel = {
    id?: string;
    firc_response_model?: FircResponseModel;
};

/**
 * Base response structure for all API responses
 */
export type GetCurrencyWalletsResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: Array<VbanDetails>;
};

/**
 * Base response structure for all API responses
 */
export type GetCustomerApiCredentialsResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: Array<CustomerApiCredentialsModel>;
};

/**
 * Get Customer by ID Response
 */
export type GetCustomerByIdResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: CustomerModel;
};

/**
 * Base response structure for all API responses
 */
export type GetCustomerSettingsResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: GetCustomerSettingsResponseModel;
};

export type GetCustomerSettingsResponseModel = {
    payout_preferences?: PayoutPreferences;
    auto_withdrawal?: AutoWithdrawal;
    auto_withdrawal_consent?: boolean;
    multi_currency_status?: MultiCurrencyStatus;
    vendor_vban_status?: VendorVbanStatus;
};

/**
 * Output for querying customers
 */
export type GetCustomersResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: Array<CustomerModel>;
};

/**
 * Base response structure for all API responses
 */
export type GetDepositsResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: Array<DepositModel>;
};

/**
 * Base response structure for all API responses
 */
export type GetEmailUnsubscribeStatusResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: UnsubscribeStatusModel;
};

/**
 * Base response structure for all API responses
 */
export type GetFeesResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: FeeResponseModel;
};

/**
 * Base response structure for all API responses
 */
export type GetFileByIdResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: FileResponseModel;
};

export type GetFileContentByIdOutputPayload = Blob | File;

/**
 * Base response structure for all API responses
 */
export type GetFilesByCustomerIdResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: GetFilesByCustomerIdResponseModel;
};

export type GetFilesByCustomerIdResponseModel = {
    documents?: Array<FileResponseModel>;
};

export type GetFircUploadResponseByIdModel = {
    firc_response_model?: FircResponseModel;
};

/**
 * Base response structure for all API responses
 */
export type GetFircUploadResponseByIdResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: GetFircUploadResponseByIdModel;
};

/**
 * Base response structure for all API responses
 */
export type GetGenericFeesResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: FeeResponseModel;
};

/**
 * Base response structure for all API responses
 */
export type GetIdentityVerificationDetailsByIdResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: GetIdentityVerificationDetailsResponseModel;
};

export type GetIdentityVerificationDetailsResponseModel = {
    verification_id: string;
    customer_id: string;
    type: VerificationType;
    business_registration_type: IndiaBusinessRegistrationType;
    status: VerificationStatus;
    steps: Array<VerificationStep>;
};

/**
 * Base response structure for all API responses
 */
export type GetIdentityVerificationsResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: GetIdentityVerificationsResponseModel;
};

export type GetIdentityVerificationsResponseModel = {
    identity_verifications: Array<IdentityVerificationSummary>;
};

/**
 * Get Invoice by ID Response
 */
export type GetInvoiceByIdResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: InvoicesModel;
};

/**
 * Get Invoice by Payout Id response
 */
export type GetInvoiceByPayoutIdResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: InvoicesModel;
};

/**
 * Base response structure for all API responses
 */
export type GetInvoicesResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: Array<InvoicesModel>;
};

/**
 * Success response containing NFC card data
 */
export type GetNfcCardDetailsResponseContent = {
    message: string;
    error?: ErrorResponse;
    data: NfcCardModel;
};

/**
 * Input for creating or retrieving a user
 */
export type GetOrCreateUserRequestContent = {
    /**
     * full name
     */
    full_name?: string;
    /**
     * email id
     */
    email?: string;
    /**
     * designation
     */
    designation?: string;
};

/**
 * Success response containing a single user
 */
export type GetOrCreateUserResponseContent = {
    message: string;
    error?: ErrorResponse;
    data: UserModel;
};

/**
 * Get Partner by ID Response
 */
export type GetPartnerByIdResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: PartnerModel;
};

/**
 * Get Partner Success Response
 */
export type GetPartnersResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: Array<PartnerModel>;
};

/**
 * Base response structure for all API responses
 */
export type GetPayoutsResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: Array<PayoutModel>;
};

/**
 * Base response structure for all API responses
 */
export type GetPayoutsSummaryResponseContent = {
    message: string;
    error?: ErrorResponse;
    /**
     * Total value of payouts settled
     */
    total_payout_settled_amount?: number;
    /**
     * Payouts count
     */
    payouts_settled_count?: number;
    /**
     * Average payout settled amount
     */
    average_payout_settled_amount?: number;
    /**
     * Median payout settled amount
     */
    median_payout_settled_amount?: number;
    /**
     * List of payouts settled
     */
    payouts?: Array<Payout>;
};

/**
 * Base response structure for all API responses
 */
export type GetPurposeCodesResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: Array<PurposeCodeModel>;
};

/**
 * Success response containing a single user
 */
export type GetUserByEmailResponseContent = {
    message: string;
    error?: ErrorResponse;
    data: UserModel;
};

/**
 * Success response containing a single user
 */
export type GetUserByIdResponseContent = {
    message: string;
    error?: ErrorResponse;
    data: UserModel;
};

/**
 * Success response containing a list of users
 */
export type GetUsersResponseContent = {
    message: string;
    error?: ErrorResponse;
    /**
     * Paginated list of users
     */
    data: Array<UserModel>;
};

export type IdentityVerificationQuery = {
    query_id: string;
    status: VerificationQueryStatus;
    system_message: {
        [key: string]: unknown;
    };
    linked_id?: string;
};

export type IdentityVerificationSummary = {
    identity_verification_id: string;
    customer_id: string;
    identity_verification_status: VerificationStatus;
    submitted_at?: string;
    business_name?: string;
    queries?: Array<IdentityVerificationQuery>;
};

export type IndiaBasicBusinessInformationData = {
    pan?: string;
    cin?: string;
    gstin?: string;
    iec_code?: string;
    no_gst_or_iec?: string;
    llp_in?: string;
    auto_populated?: boolean;
    error_code?: string;
    business_name?: string;
    authorized_person_name?: string;
    address?: Address;
    billing_address?: Address;
    non_editable_fields?: Array<IndiaBasicBusinessInformationNonEditableEnum>;
    business_activity?: BusinessActivityType;
    doing_business_as?: string;
    support_documents?: Array<SupportDocument>;
};

export type IndiaBasicBusinessInformationNonEditableEnum = 'PAN' | 'CIN' | 'GSTIN' | 'NAME' | 'AUTHORIZED_OWNER_NAME';

export type IndiaBusinessBankDetailsData = {
    account_number?: string;
    confirm_account_number?: string;
    ifsc_code?: string;
    name_as_per_bank?: string;
    name_as_entered?: string;
    account_holder_name_matched?: boolean;
    account_holder_name_verification_notice?: string;
};

export type IndiaBusinessComplianceQuestionsData = {
    software_for_military?: string;
    voip_services?: string;
};

export type IndiaBusinessDirectorDetailsData = {
    director_detail_list?: Array<DirectorDetails>;
};

export type IndiaBusinessRegistrationType = 'PRIVATE_LIMITED_COMPANY' | 'PUBLIC_LIMITED_COMPANY' | 'PARTNERSHIPS' | 'LLP_REGISTRATION' | 'ONE_PERSON_COMPANY' | 'SOLE_PROPRIETORSHIP' | 'SECTION_8_COMPANY';

export type IndianBankAccount = {
    /**
     * Bank account ID
     */
    id?: string;
    /**
     * Bank account number
     */
    account_no?: string;
    /**
     * Account type
     */
    account_type?: string;
    /**
     * Bank's IFSC code
     */
    ifsc_code?: string;
    /**
     * Bank name
     */
    bank_name?: string;
    /**
     * Bank branch
     */
    bank_branch?: string;
    /**
     * Account name
     */
    account_name?: string;
    /**
     * Whether this bank account is the default payout account
     */
    is_default?: boolean;
};

/**
 * Base response structure for all API responses
 */
export type InternalErrorResponseContent = {
    message: string;
    error?: ErrorResponse;
};

/**
 * Base response structure for all API responses
 */
export type InvalidOtpErrorResponseContent = {
    message: string;
    error?: ErrorResponse;
};

export type InvoiceRequestPayload = {
    billing_start_date: string;
    billing_end_date: string;
    invoice_date: string;
    invoice_due_date: string;
    currency: Currency;
    invoice_number: string;
    items: Array<Item>;
    sub_total: number;
    vat_percentage: number;
    vat: number;
    total: number;
    purpose_of_transaction: string;
    purpose_code: string;
    invoice_note: string;
    transaction_type: InvoiceTransactionType;
    partner_id: string;
    support_documents: Array<InvoiceSupportDocument>;
};

export type InvoiceStatus = 'DRAFT' | 'UNPAID' | 'PAID' | 'OVERDUE' | 'PARTIALLY_PAID' | 'REJECTED' | 'CANCELLED' | 'VERIFYING';

export type InvoiceSupportDocument = {
    name?: string;
    purpose?: Purpose;
    document_id?: string;
    size?: number;
    mime_type?: string;
};

export type InvoiceTimelineEvent = {
    title: string;
    message: string;
    time: string;
    type: InvoiceTimelineEventType;
};

export type InvoiceTimelineEventType = 'INVOICE_CREATED' | 'INVOICE_UPDATED' | 'INVOICE_PUBLISHED' | 'INVOICE_VERIFIED' | 'INVOICE_UNPAID' | 'INVOICE_PARTIALLY_PAID' | 'INVOICE_PAID' | 'INVOICE_CANCELLED' | 'WITHDRAWAL_INITIATED' | 'WITHDRAWAL_PROCESSING' | 'WITHDRAWAL_SETTLED' | 'WITHDRAWAL_FAILED' | 'PAYOUT_ARRIVAL_TIME_UPDATED' | 'FIRC_GENERATED';

export type InvoiceTransactionType = 'goods' | 'services' | 'software';

export type InvoiceUpdateOperations = 'PUBLISH' | 'REVOKE';

export type InvoicesModel = {
    id: string;
    partner_id: string;
    billing_start_date: string;
    billing_end_date: string;
    invoice_date: string;
    invoice_due_date: string;
    invoice_number: string;
    items: Array<Item>;
    sub_total: number;
    vat_percentage: number;
    vat: number;
    total: number;
    due_amount: number;
    currency: Currency;
    purpose_of_transaction: string;
    purpose_code: string;
    invoice_note: string;
    transaction_type: InvoiceTransactionType;
    status: InvoiceStatus;
    invoice_document?: string;
    support_documents?: Array<InvoiceSupportDocument>;
    timeline?: Array<InvoiceTimelineEvent>;
};

export type Item = {
    item: string;
    quantity: number;
    price: number;
    total: number;
};

export type LinkedCustomer = {
    customer_id: string;
    registered_email: string;
    registered_name: string;
    verification_status: string;
    verified_at: string;
    created_at: string;
    fee: FeeResponseModel;
};

export type MimeType = 'JPEG' | 'PNG' | 'PDF' | 'MS_EXCEL';

export type Money = {
    amount: number;
    currency: Currency;
};

export type MultiCurrencyStatus = 'PENDING' | 'VERIFYING' | 'ACTIVATED';

/**
 * NFC Card model containing card details
 */
export type NfcCardModel = {
    /**
     * Unique identifier of the NFC card
     */
    id: string;
    /**
     * User ID associated with the NFC card
     */
    user_id: string;
    /**
     * Name on the NFC card
     */
    name: string;
    /**
     * Email associated with the NFC card
     */
    email: string;
    /**
     * Company name
     */
    company?: string;
    /**
     * Title/Designation
     */
    title?: string;
    /**
     * Mobile number
     */
    mobile?: string;
    /**
     * Profile picture URL
     */
    profile_url?: string;
    /**
     * External Profile Id
     */
    external_profile_id?: string;
    /**
     * Design Id
     */
    design_id?: string;
    /**
     * Image Id
     */
    svg_content?: string;
    /**
     * create time of NFC card
     */
    create_time?: string;
    /**
     * update time of NFC card
     */
    update_time?: string;
};

export type OperationInputs = {
    /**
     * Valid for the publish operation - Sending Email copy to sender
     */
    send_me_a_copy?: boolean;
};

export type OwnerAddress = {
    /**
     * Address line-1
     */
    address_line1?: string;
    /**
     * Address line-2
     */
    address_line2?: string;
    country_code?: CountryIsoCode;
    /**
     * State
     */
    state?: string;
    /**
     * City
     */
    city?: string;
    /**
     * Pin code
     */
    pin_code?: string;
};

export type PartnerAccountDetails = {
    contact_person_name: string;
    contact_person_email: string;
    contact_person_ph_no: string;
    client_code: string;
    last_invoice_number: number;
    due_date_count: number;
    due_date_frequency: Term;
};

export type PartnerModel = {
    id?: string;
    business_name?: string;
    business_email?: string;
    contact_person?: string;
    contact_person_phone_number?: string;
    status?: PartnerStatus;
    country_code?: CountryIsoCode;
    created_time?: string;
    revoked_date?: string;
    revoked_reason?: string;
    /**
     * Multiple Partner bank details provided by service provider
     */
    bank_details_list?: Array<BankDetails>;
    wallet_balance?: WalletBalance;
    partner_account_details?: PartnerAccountDetails;
    address?: Address;
    /**
     * Boolean to identify partner VBAN existence
     */
    partnerVbanExists?: boolean;
};

export type PartnerStatus = 'REQUESTED' | 'APPROVED' | 'REJECTED';

/**
 * Base request structure containing organization ID
 */
export type PatchBankAccountRequestContent = {
    /**
     * Boolean to make bank account as default
     */
    is_default: boolean;
};

/**
 * Base response structure for all API responses
 */
export type PatchBankAccountResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: IndianBankAccount;
};

/**
 * Base request structure containing organization ID
 */
export type PatchBeneficialOwnerRequestContent = {
    /**
     * PAN document id
     */
    pan_file_id: string;
    /**
     * Address document id
     */
    address_file_id?: string;
    owner_address?: OwnerAddress;
    operation?: PatchOwnerOperation;
};

/**
 * Base response structure for all API responses
 */
export type PatchBeneficialOwnerResponseContent = {
    message: string;
    error?: ErrorResponse;
    /**
     * Beneficial owner name
     */
    beneficial_owner?: string;
    /**
     * Beneficial owner PAN number
     */
    beneficial_owner_pan?: string;
    /**
     * PAN document id
     */
    pan_file_id?: string;
    /**
     * UBO identity
     */
    isUbo?: boolean;
    address_model?: AddressModel;
};

export type PatchCustomerApiCredentialsModel = {
    api_key?: string;
    status?: CustomerApiCredentialStatus;
    revoke_reason?: string;
    api_secret?: string;
};

/**
 * Perform a lifecycle operation on API credentials
 */
export type PatchCustomerApiCredentialsRequestContent = {
    operation: CustomerApiCredentialOperations;
    operation_inputs?: CustomerApiCredentialOperationInputs;
};

/**
 * Base response structure for all API responses
 */
export type PatchCustomerApiCredentialsResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: PatchCustomerApiCredentialsModel;
};

export type PatchCustomerOperations = 'UPDATEASDEFAULT' | 'REMOVE_COMPANY_LOGO';

/**
 * Base request structure containing organization ID
 */
export type PatchCustomerRequestContent = {
    /**
     * Customer ID
     */
    id: string;
    operation: PatchCustomerOperations;
};

/**
 * Response For Patch Customer by ID
 */
export type PatchCustomerResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: CustomerModel;
};

/**
 * Base request structure containing organization ID
 */
export type PatchCustomerSettingsRequestContent = {
    payout_frequency?: PayoutFrequency;
    weekly_anchor?: WeeklyAnchor;
    /**
     * Date of the Month
     */
    monthly_anchor?: number;
    /**
     * logo id
     */
    logo_id?: string;
    auto_withdrawal?: AutoWithdrawal;
    /**
     * Enable vendor level VBAN
     */
    enable_vendor_vban?: boolean;
    /**
     * auto withdrawal consent
     */
    auto_withdrawal_consent?: boolean;
};

/**
 * Base response structure for all API responses
 */
export type PatchCustomerSettingsResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: PatchCustomerSettingsResponseModel;
};

export type PatchCustomerSettingsResponseModel = {
    payoutPreferences?: PayoutPreferences;
    logo_id?: string;
    auto_withdrawal?: AutoWithdrawal;
    vendor_vban_enabe?: boolean;
};

/**
 * Base request structure containing organization ID
 */
export type PatchDepositRequestContent = {
    /**
     * Partner Id
     */
    partner_id?: string;
};

/**
 * Base response structure for all API responses
 */
export type PatchDepositResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: PatchDepositResponseModel;
};

/**
 * Base response structure for all API responses
 */
export type PatchDepositResponseModel = {
    message: string;
    error?: ErrorResponse;
    /**
     * Deposit transfer id
     */
    transfer_id?: string;
};

/**
 * Base request structure containing organization ID
 */
export type PatchIdentityVerificationQueryDocumentsRequestContent = {
    query_id: string;
    file_id: string;
    purpose: Purpose;
};

/**
 * Base response structure for all API responses
 */
export type PatchIdentityVerificationQueryDocumentsResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: PatchIdentityVerificationQueryDocumentsResponseModel;
};

export type PatchIdentityVerificationQueryDocumentsResponseModel = {
    verification_id: string;
    query_id: string;
    file_id: string;
    status: VerificationQueryStatus;
};

export type PatchOwnerOperation = 'REMOVE_UBO';

/**
 * Base request structure containing organization ID
 */
export type PatchUserRequestContent = {
    /**
     * User name to be updated
     */
    name?: string;
    /**
     * User's phone number
     */
    phone_number?: string;
    /**
     * file_id
     */
    file_id?: string;
};

/**
 * Base response structure for all API responses
 */
export type PatchUserResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: UserModel;
};

/**
 * Base response structure for all API responses
 */
export type PatchVerificationFlowSubmissionResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: PatchVerificationFlowSubmissionResponseDataModel;
};

export type PatchVerificationFlowSubmissionResponseDataModel = {
    verification_id: string;
    status: VerificationStatus;
};

/**
 * Base request structure containing organization ID
 */
export type PatchVerificationStepDataRequestContent = {
    operation: VerificationStepOperations;
    step_data: VerificationStepData;
};

/**
 * Base response structure for all API responses
 */
export type PatchVerificationStepDataResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: PatchVerificationStepDataResponseModel;
};

export type PatchVerificationStepDataResponseModel = {
    verification_id?: string;
    status?: VerificationStatus;
    steps?: Array<VerificationStep>;
    step_data_error_list?: Array<StepDataError>;
};

export type PaymentMethod = 'ACH' | 'RTP' | 'FEDWIRE' | 'SWIFT' | 'SEPA_CREDIT' | 'SEPA_INSTANT' | 'FPS' | 'EFT';

export type Payout = {
    /**
     * Payout settled date
     */
    payout_date?: string;
    /**
     * Payout settled amount
     */
    payout_amount?: number;
};

export type PayoutBankDetails = {
    account_number?: string;
    ifsc_code?: string;
    currency?: Currency;
    bank_name?: string;
    bank_address?: string;
    account_name?: string;
    is_default?: boolean;
};

export type PayoutFrequency = 'daily' | 'weekly' | 'monthly';

/**
 * Details of a payout transaction
 */
export type PayoutModel = {
    /**
     * Unique identifier for the payout
     */
    id: string;
    /**
     * Date and time when the payout was initiated
     */
    initiation_date?: string;
    /**
     * Expected arrival date and time of the payout
     */
    arrival?: string;
    gross_amount?: Money;
    net_amount?: Money;
    settled_amount?: Money;
    /**
     * External reference identifier
     */
    reference_id?: string;
    /**
     * FRIC id or Payout Receipt
     */
    receipt_file_id?: string;
    status?: PayoutStatus;
    /**
     * Unique transaction reference number
     */
    unique_transaction_reference?: string;
};

export type PayoutPreferences = {
    payout_frequency?: PayoutFrequency;
    weekly_anchor?: WeeklyAnchor;
    monthly_anchor?: number;
};

export type PayoutRequest = {
    invoice_id: string;
    reconciliation_amount: number;
    /**
     * indian_bank_account.id selected by the user for this payout
     */
    bank_id: string;
};

export type PayoutRequestResponse = {
    invoice_id?: string;
    status?: string;
    message?: string;
};

/**
 * Enumeration of possible payout statuses
 */
export type PayoutStatus = 'INITIALIZED' | 'PROCESSING' | 'SETTLED' | 'FAILED' | 'HOLD';

/**
 * Base request structure containing organization ID
 */
export type PostAffiliateUserRequestContent = {
    /**
     * Unique identifier of the user
     */
    user_id: string;
    /**
     * Affiliate code chosen by the user
     */
    affiliate_code: string;
    /**
     * Whether it is a premium manager
     */
    is_premium_affiliate?: boolean;
};

/**
 * Base response structure for all API responses
 */
export type PostAffiliateUserResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: AffiliateUserData;
};

/**
 * Base request structure containing organization ID
 */
export type PostBeneficialOwnerRequestContent = {
    /**
     * Beneficial owner's name
     */
    beneficial_owner_name?: string;
    /**
     * Beneficial owner's PAN number
     */
    beneficial_owner_pan?: string;
    /**
     * PAN document id
     */
    pan_file_id: string;
    /**
     * Address document id
     */
    address_file_id?: string;
    owner_address?: OwnerAddress;
};

/**
 * Base response structure for all API responses
 */
export type PostBeneficialOwnerResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: BeneficialOwner;
};

/**
 * Base request structure containing organization ID
 */
export type PostCompliancePackageRequestRequestContent = {
    from_time: string;
    to_time: string;
    purpose: Purpose;
};

/**
 * Base response structure for all API responses
 */
export type PostCompliancePackageRequestResponseContent = {
    message: string;
    error?: ErrorResponse;
    request_id?: string;
    request_status?: RequestStatus;
};

export type PostContactFormRequestContent = {
    name: string;
    email: string;
    phone: string;
    message: string;
};

/**
 * Base response structure for all API responses
 */
export type PostContactFormResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: ContactFormResponseModel;
};

/**
 * Base request structure containing organization ID
 */
export type PostCurrencyWalletRequestContent = {
    currency: Currency;
};

/**
 * Base response structure for all API responses
 */
export type PostCurrencyWalletResponseContent = {
    message: string;
    error?: ErrorResponse;
    currency?: Currency;
    /**
     * Customer ID
     */
    customer_id?: string;
    /**
     * Multiple Vendor bank details provided by service provider
     */
    bank_details_list?: Array<VbanDetails>;
};

export type PostCustomerApiCredentialsModel = {
    /**
     * Public API key sent on each signed request
     */
    api_key: string;
    /**
     * Private signing secret. Shown only once at creation.
     */
    api_secret: string;
    organization_id: string;
    customer_id: string;
    name: string;
    status: CustomerApiCredentialStatus;
};

/**
 * Base response structure for all API responses
 */
export type PostCustomerApiCredentialsResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: PostCustomerApiCredentialsModel;
};

export type PostEmailUnsubscribeRequestContent = {
    reason: string;
    other_reason?: string;
};

/**
 * Base response structure for all API responses
 */
export type PostEmailUnsubscribeResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: UnsubscribeStatusModel;
};

/**
 * Base request structure containing organization ID
 */
export type PostIdentityVerificationRequestContent = {
    customer_id: string;
    type: VerificationType;
    business_registration_type: IndiaBusinessRegistrationType;
    country_iso_code: CountryIsoCode;
};

/**
 * Base response structure for all API responses
 */
export type PostIdentityVerificationResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: PostIdentityVerificationResponseDataModel;
};

export type PostIdentityVerificationResponseDataModel = {
    verification_id: string;
    status: VerificationStatus;
    steps: Array<VerificationStep>;
};

/**
 * Base request structure containing organization ID
 */
export type PostInvoiceOverdueReminderRequestContent = {
    /**
     * InvoiceIds
     */
    invoice_ids?: Array<string>;
};

/**
 * Send invoice overdue reminders response
 */
export type PostInvoiceOverdueReminderResponseContent = {
    message: string;
    error?: ErrorResponse;
};

/**
 * Base request structure containing organization ID
 */
export type PostMultiCurrencyEnableRequestContent = {
    estimated_monthly_volume?: Money;
};

/**
 * Base response structure for all API responses
 */
export type PostMultiCurrencyEnableResponseContent = {
    message: string;
    error?: ErrorResponse;
    status?: string;
};

/**
 * Base request structure containing organization ID
 */
export type PostPayoutsPreviewRequestContent = {
    invoice_id: string;
    reconciliation_amount: number;
};

/**
 * Base response structure for all API responses
 */
export type PostPayoutsPreviewResponseContent = {
    message: string;
    error?: ErrorResponse;
    invoice_id?: string;
    expected_settlement_date?: string;
    timeline_list?: Array<Timeline>;
};

/**
 * Request do the withdrawal
 */
export type PostPayoutsRequestContent = {
    payout_requests?: Array<PayoutRequest>;
};

/**
 * Base response structure for all API responses
 */
export type PostPayoutsResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: Array<PayoutRequestResponse>;
};

/**
 * Base request structure containing organization ID
 */
export type PostPurposeCodesRequestContent = {
    purpose_codes: Array<string>;
};

/**
 * Base response structure for all API responses
 */
export type PostPurposeCodesResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: Array<PurposeCodesRequestResponse>;
};

export type PostXflowWebhookInputPayload = string;

/**
 * Base response structure for all API responses
 */
export type PostXflowWebhookResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: WebhookResponseModel;
};

export type Purpose = 'COMPANY_LOGO' | 'ADDITIONAL_INVOICE_DOCUMENT' | 'GST_IN_DOCUMENT' | 'DEED_DOCUMENT' | 'IEC_DOCUMENT' | 'NO_GST_AND_IEC_DOCUMENT' | 'PAYOUT_FIRC' | 'INVOICE_DOCUMENT' | 'USER_PROFILE_PICTURE' | 'KYB_DOC_OLD_INVOICE' | 'KYB_DOC_OLD_FIRC' | 'KYB_DOC_CERTIFICATE_ISSUED_BY_MUNICIPAL_AUTHORITY' | 'KYB_DOC_CERTIFICATE_ISSUED_BY_TAX_AUTHORITY' | 'KYB_DOC_UDYAM_CERTIFICATE' | 'KYB_DOC_UTILITY_BILL' | 'KYB_DOC_CONTRACT_AGREEMENT' | 'HDFC_IRM_REPORT' | 'HDFC_REQUEST_LETTER' | 'COMPLIANCE_PACKAGE' | 'COMPLIANCE_PACKAGE_INVOICES' | 'COMPLIANCE_PACKAGE_PAYOUTS' | 'UBO_PAN' | 'UBO_HOME_ADDRESS_PROOF';

export type PurposeCode = {
    purpose_code?: string;
};

export type PurposeCodeModel = {
    /**
     * Purpose code
     */
    code?: string;
    /**
     * Purpose code status
     */
    status?: string;
};

export type PurposeCodesRequestResponse = {
    code?: string;
    status?: string;
    message?: string;
};

export type RequestLetterPayload = {
    payout_settled_date?: string;
    bank_branch?: string;
    bank_account_number?: string;
    unique_transaction_reference?: string;
    currency?: string;
    transaction_amount?: string;
    payout_reference_id?: string;
    foreign_remitter?: string;
    remitting_bank?: string;
    remitting_bank_swift_code?: string;
    beneficiary_account_number?: string;
    beneficiary?: string;
    purpose_code?: string;
};

export type RequestStatus = 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'EXPIRED' | 'FAILED';

/**
 * Base response structure for all API responses
 */
export type ResourceNotFoundErrorResponseContent = {
    message: string;
    error?: ErrorResponse;
};

/**
 * Base request structure containing organization ID
 */
export type SendOtpRequestContent = {
    /**
     * phone number
     */
    phone_number: string;
    verification_operation: VerificationOperation;
};

/**
 * Base response structure for all API responses
 */
export type SendOtpResponseContent = {
    message: string;
    error?: ErrorResponse;
    data: VerifyOtpResponseModel;
};

export type Source = 'VENDOR_VBAN' | 'PARTNER_VBAN';

export type StepDataError = {
    error_code: string;
    error_description?: string;
};

/**
 * Success response containing a single user
 */
export type SyncUserResponseContent = {
    message: string;
    error?: ErrorResponse;
    data: UserModel;
};

export type Term = 'DAYS' | 'MONTHS';

export type Timeline = {
    [key: string]: string;
};

export type UsBasicBusinessInformationData = {
    name?: string;
    billing_address?: Address;
    federal_ein?: string;
    date_established?: string;
    nature_of_business?: BusinessActivityType;
    authorized_officer_full_name?: string;
    designation?: string;
    verification_document_id?: string;
};

export type UsBusinessComplianceQuestionsData = {
    software_for_military?: string;
    voip_services?: string;
};

/**
 * Base response structure for all API responses
 */
export type UnprocessableEntityErrorResponseContent = {
    message: string;
    error?: ErrorResponse;
};

export type UnsubscribeStatusModel = {
    unsubscribed: boolean;
};

/**
 * Base request structure containing organization ID
 */
export type UpdateAffiliateCustomerFeeRequestContent = {
    fee: UpdateFeeRequest;
};

/**
 * Base response structure for all API responses
 */
export type UpdateAffiliateCustomerFeeResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: UpdateFeeResponseData;
};

export type UpdateFeeRequest = {
    fixed_fee: number;
    variable_fee_percentage: number;
    minimum_amount: number;
    fx_rate: number;
    sell_currency: string;
    buy_currency: string;
};

export type UpdateFeeResponseData = {
    customer_id: string;
    message: string;
};

/**
 * Base request structure containing organization ID
 */
export type UpdateInvoiceByIdRequestContent = {
    operation: InvoiceUpdateOperations;
    operation_inputs?: OperationInputs;
};

/**
 * Update Invoice By Id response
 */
export type UpdateInvoiceByIdResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: InvoicesModel;
};

/**
 * Input for updating partner
 */
export type UpdatePartnerRequestContent = {
    partner_account_details: PartnerAccountDetails;
};

/**
 * Update Partner Response
 */
export type UpdatePartnerResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: PartnerModel;
};

export type UploadFileInputPayload = Blob | File;

/**
 * Base response structure for all API responses
 */
export type UploadFileResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: UploadFileResponseModel;
};

export type UploadFileResponseModel = {
    /**
     * File Id
     */
    file_id?: string;
};

/**
 * User model containing user details
 */
export type UserModel = {
    /**
     * Unique identifier of the user
     */
    id: string;
    /**
     * Client-specific user identifier
     */
    client_user_id: string;
    /**
     * User's email address
     */
    email: string;
    /**
     * User's active status
     */
    is_active: boolean;
    /**
     * User's active customer id
     */
    current_context_customer_id: string;
    /**
     * User name
     */
    name?: string;
    /**
     * designation of user in organization
     */
    designation?: string;
    affiliate_manager?: boolean;
    /**
     * Affiliate referral code assigned
     */
    affiliate_code?: string;
    /**
     * create time of user
     */
    create_time?: string;
    phone_number?: string;
};

export type VbanDetails = {
    currency?: Currency;
    bank_name?: string;
    account_type?: string;
    domestic_credit?: string;
    domestic_debit?: string;
    domestic_fast_credit?: string;
    domestic_wire?: string;
    global_wire?: string;
    iban?: string;
    last4?: string;
    number?: string;
    type?: BankAccountType;
};

export type VendorVbanStatus = 'PENDING' | 'ACTIVATED';

export type VerificationOperation = 'MOBILE_NUMBER_VERIFICATION' | 'EMAIL_VERIFICATION';

export type VerificationQueryStatus = 'PENDING' | 'SUBMITTED' | 'FAILED';

export type VerificationStatus = 'PENDING' | 'IN_PROGRESS' | 'UNDER_REVIEW' | 'APPROVED' | 'REJECTED' | 'INPUT_REQUIRED';

export type VerificationStep = {
    name: VerificationStepName;
    status: VerificationStepStatus;
    verification_step_data?: VerificationStepData;
    step_data_error_list?: Array<StepDataError>;
};

export type VerificationStepData = {
    india_basic_business_information: IndiaBasicBusinessInformationData;
} | {
    india_business_director_details: IndiaBusinessDirectorDetailsData;
} | {
    india_business_compliance_questions: IndiaBusinessComplianceQuestionsData;
} | {
    india_business_bank_details: IndiaBusinessBankDetailsData;
} | {
    business_credibility_information: BusinessCredibilityInformationData;
} | {
    us_basic_business_information: UsBasicBusinessInformationData;
} | {
    us_business_compliance_questions: UsBusinessComplianceQuestionsData;
};

export type VerificationStepName = 'IN_BASIC_BUSINESS_INFORMATION' | 'IN_BUSINESS_DIRECTOR_DETAILS' | 'IN_BUSINESS_COMPLIANCE_QUESTIONS' | 'IN_BUSINESS_BANK_DETAILS' | 'BUSINESS_CREDIBILITY_INFORMATION' | 'US_BASIC_BUSINESS_INFORMATION' | 'US_BUSINESS_COMPLIANCE_QUESTIONS';

export type VerificationStepOperations = 'SEARCHFORPANORCIN' | 'SUBMIT' | 'SAVE';

export type VerificationStepStatus = 'COMPLETE' | 'IN_PROGRESS' | 'PENDING';

export type VerificationType = 'KYC' | 'KYB' | 'BANK_ACCOUNT_VERIFICATION';

/**
 * Base request structure containing organization ID
 */
export type VerifyOtpRequestContent = {
    /**
     * phone number
     */
    phone_number: string;
    /**
     * Otp sent by user for verification
     */
    otp: string;
    verification_operation: VerificationOperation;
};

/**
 * Base response structure for all API responses
 */
export type VerifyOtpResponseContent = {
    message: string;
    error?: ErrorResponse;
    data?: VerifyOtpResponseModel;
};

export type VerifyOtpResponseModel = {
    status: string;
    verification_operation: VerificationOperation;
};

export type WalletBalance = {
    amount?: number;
    currency?: Currency;
};

export type WebhookResponseModel = {
    status: string;
    processed: boolean;
};

export type WeeklyAnchor = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday';

export type CustomerModel = {
    id?: string;
    name?: string;
    emails?: Array<string>;
    address?: Address;
    phone_numbers?: Array<string>;
    profile_picture?: string;
    created_date?: string;
    status?: CustomerStatus;
    business_registration_type?: IndiaBusinessRegistrationType;
    payout_bank_details?: Array<PayoutBankDetails>;
    verified_at?: string;
    vban_details_list?: Array<VbanDetails>;
    wallet_balance_list?: Array<WalletBalance>;
};

export type DepositModel = {
    /**
     * Deposit Id
     */
    deposit_id?: string;
    /**
     * Partner Id
     */
    partner_id?: string;
    currency?: Currency;
    /**
     * Deposit amount
     */
    amount?: number;
    source?: Source;
    /**
     * Deposit status-Classified/Unclassified
     */
    status?: string;
    /**
     * Statement descriptor
     */
    statement_descriptor?: string;
    /**
     * B2B provider
     */
    b2b_provider?: string;
    payment_method?: PaymentMethod;
    /**
     * Deposit receipt date-time
     */
    received_at?: string;
};

export type FeeResponseModel = {
    /**
     * Fixed fee amount
     */
    fixed_fee?: number;
    /**
     * Minimum Amount
     */
    minimum_amount?: number;
    /**
     * Variable fee percentage
     */
    variable_fee_percentage?: number;
    /**
     * Variable fee Amount
     */
    variable_fee?: number;
    /**
     * Fx Fee % on the conversion rate
     */
    fx_rate?: number;
    /**
     * Total Fee
     */
    total_fee?: number;
    /**
     * Mid market exchange rate
     */
    mid_market_rate?: number;
    /**
     * User's conversion rate
     */
    user_conversion_rate?: number;
    /**
     * INR value
     */
    buy_amount?: number;
    /**
     * INR value
     */
    buy_currency?: string;
    /**
     * USD value
     */
    sell_amount?: number;
    /**
     * USD value
     */
    sell_currency?: string;
    /**
     * USD value
     */
    gross_amount?: number;
    /**
     * Fee validity timestamp
     */
    valid_till?: string;
};

export type SupportDocument = {
    type?: string;
    name?: string;
    file_id?: string;
};

export type GetAffiliateCommissionsData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/affiliate/commissions';
};

export type GetAffiliateCommissionsResponses = {
    /**
     * GetAffiliateCommissions 200 response
     */
    200: GetAffiliateCommissionsResponseContent;
};

export type GetAffiliateCommissionsResponse = GetAffiliateCommissionsResponses[keyof GetAffiliateCommissionsResponses];

export type GetAffiliateCustomersData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/affiliate/customers';
};

export type GetAffiliateCustomersResponses = {
    /**
     * GetAffiliateCustomers 200 response
     */
    200: GetAffiliateCustomersResponseContent;
};

export type GetAffiliateCustomersResponse = GetAffiliateCustomersResponses[keyof GetAffiliateCustomersResponses];

export type UpdateAffiliateCustomerFeeData = {
    body: UpdateAffiliateCustomerFeeRequestContent;
    headers: {
        'X-Organization-ID': string;
    };
    path: {
        cid: string;
    };
    query?: never;
    url: '/api/v1/affiliate/customers/{cid}';
};

export type UpdateAffiliateCustomerFeeResponses = {
    /**
     * UpdateAffiliateCustomerFee 200 response
     */
    200: UpdateAffiliateCustomerFeeResponseContent;
};

export type UpdateAffiliateCustomerFeeResponse = UpdateAffiliateCustomerFeeResponses[keyof UpdateAffiliateCustomerFeeResponses];

export type PostAffiliateUserData = {
    body: PostAffiliateUserRequestContent;
    headers: {
        'X-Organization-ID': string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/affiliate/users';
};

export type PostAffiliateUserErrors = {
    /**
     * BadRequestError 400 response
     */
    400: BadRequestErrorResponseContent;
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * ResourceNotFoundError 404 response
     */
    404: ResourceNotFoundErrorResponseContent;
};

export type PostAffiliateUserError = PostAffiliateUserErrors[keyof PostAffiliateUserErrors];

export type PostAffiliateUserResponses = {
    /**
     * PostAffiliateUser 200 response
     */
    200: PostAffiliateUserResponseContent;
};

export type PostAffiliateUserResponse = PostAffiliateUserResponses[keyof PostAffiliateUserResponses];

export type GetAnalyticsForPayoutsGraphData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query: {
        /**
         * from date for the graph
         */
        from_date: string;
        /**
         * to date for the graph
         */
        to_date: string;
    };
    url: '/api/v1/analytics/payouts_graph';
};

export type GetAnalyticsForPayoutsGraphResponses = {
    /**
     * GetAnalyticsForPayoutsGraph 200 response
     */
    200: GetAnalyticsForPayoutsGraphResponseContent;
};

export type GetAnalyticsForPayoutsGraphResponse = GetAnalyticsForPayoutsGraphResponses[keyof GetAnalyticsForPayoutsGraphResponses];

export type GetPayoutsSummaryData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
    };
    path?: never;
    query: {
        /**
         * from date for the payouts summary
         */
        from_date: string;
        /**
         * to date for the payouts summary
         */
        to_date: string;
    };
    url: '/api/v1/analytics/payouts_summary';
};

export type GetPayoutsSummaryResponses = {
    /**
     * GetPayoutsSummary 200 response
     */
    200: GetPayoutsSummaryResponseContent;
};

export type GetPayoutsSummaryResponse = GetPayoutsSummaryResponses[keyof GetPayoutsSummaryResponses];

export type GetCustomerApiCredentialsData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * Customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/api-credentials';
};

export type GetCustomerApiCredentialsErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * ResourceNotFoundError 404 response
     */
    404: ResourceNotFoundErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type GetCustomerApiCredentialsError = GetCustomerApiCredentialsErrors[keyof GetCustomerApiCredentialsErrors];

export type GetCustomerApiCredentialsResponses = {
    /**
     * GetCustomerApiCredentials 200 response
     */
    200: GetCustomerApiCredentialsResponseContent;
};

export type GetCustomerApiCredentialsResponse = GetCustomerApiCredentialsResponses[keyof GetCustomerApiCredentialsResponses];

export type PostCustomerApiCredentialsData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * Customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/api-credentials';
};

export type PostCustomerApiCredentialsErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type PostCustomerApiCredentialsError = PostCustomerApiCredentialsErrors[keyof PostCustomerApiCredentialsErrors];

export type PostCustomerApiCredentialsResponses = {
    /**
     * PostCustomerApiCredentials 200 response
     */
    200: PostCustomerApiCredentialsResponseContent;
};

export type PostCustomerApiCredentialsResponse = PostCustomerApiCredentialsResponses[keyof PostCustomerApiCredentialsResponses];

export type PatchCustomerApiCredentialsData = {
    body: PatchCustomerApiCredentialsRequestContent;
    headers: {
        'X-Organization-ID': string;
        customer_id: string;
    };
    path: {
        api_key: string;
    };
    query?: never;
    url: '/api/v1/api-credentials/{api_key}';
};

export type PatchCustomerApiCredentialsErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * ResourceNotFoundError 404 response
     */
    404: ResourceNotFoundErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type PatchCustomerApiCredentialsError = PatchCustomerApiCredentialsErrors[keyof PatchCustomerApiCredentialsErrors];

export type PatchCustomerApiCredentialsResponses = {
    /**
     * PatchCustomerApiCredentials 200 response
     */
    200: PatchCustomerApiCredentialsResponseContent;
};

export type PatchCustomerApiCredentialsResponse = PatchCustomerApiCredentialsResponses[keyof PatchCustomerApiCredentialsResponses];

export type GetBankAccountsData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/bank_accounts';
};

export type GetBankAccountsErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type GetBankAccountsError = GetBankAccountsErrors[keyof GetBankAccountsErrors];

export type GetBankAccountsResponses = {
    /**
     * GetBankAccounts 200 response
     */
    200: GetBankAccountsResponseContent;
};

export type GetBankAccountsResponse = GetBankAccountsResponses[keyof GetBankAccountsResponses];

export type PatchBankAccountData = {
    body: PatchBankAccountRequestContent;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path: {
        /**
         * Bank account ID
         */
        bank_account_id: string;
    };
    query?: never;
    url: '/api/v1/bank_accounts/{bank_account_id}';
};

export type PatchBankAccountErrors = {
    /**
     * BadRequestError 400 response
     */
    400: BadRequestErrorResponseContent;
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * ResourceNotFoundError 404 response
     */
    404: ResourceNotFoundErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type PatchBankAccountError = PatchBankAccountErrors[keyof PatchBankAccountErrors];

export type PatchBankAccountResponses = {
    /**
     * PatchBankAccount 200 response
     */
    200: PatchBankAccountResponseContent;
};

export type PatchBankAccountResponse = PatchBankAccountResponses[keyof PatchBankAccountResponses];

export type GetBankAccountByPayoutIdData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * Customer ID
         */
        customer_id: string;
    };
    path: {
        /**
         * Payout ID
         */
        payout_id: string;
    };
    query?: never;
    url: '/api/v1/bank_accounts/{payout_id}';
};

export type GetBankAccountByPayoutIdErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type GetBankAccountByPayoutIdError = GetBankAccountByPayoutIdErrors[keyof GetBankAccountByPayoutIdErrors];

export type GetBankAccountByPayoutIdResponses = {
    /**
     * GetBankAccountByPayoutId 200 response
     */
    200: GetBankAccountByPayoutIdResponseContent;
};

export type GetBankAccountByPayoutIdResponse = GetBankAccountByPayoutIdResponses[keyof GetBankAccountByPayoutIdResponses];

export type GetCompliancePackageRequestsData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: {
        /**
         * Optional request ID for polling
         */
        request_id?: string;
    };
    url: '/api/v1/compliance-package';
};

export type GetCompliancePackageRequestsResponses = {
    /**
     * GetCompliancePackageRequests 200 response
     */
    200: GetCompliancePackageRequestsResponseContent;
};

export type GetCompliancePackageRequestsResponse = GetCompliancePackageRequestsResponses[keyof GetCompliancePackageRequestsResponses];

export type PostCompliancePackageRequestData = {
    body: PostCompliancePackageRequestRequestContent;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/compliance-package';
};

export type PostCompliancePackageRequestResponses = {
    /**
     * PostCompliancePackageRequest 200 response
     */
    200: PostCompliancePackageRequestResponseContent;
};

export type PostCompliancePackageRequestResponse = PostCompliancePackageRequestResponses[keyof PostCompliancePackageRequestResponses];

export type DownloadCompliancePackageData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path: {
        /**
         * Request ID
         */
        request_id: string;
    };
    query?: never;
    url: '/api/v1/compliance-package/{request_id}/download';
};

export type DownloadCompliancePackageResponses = {
    /**
     * DownloadCompliancePackage 200 response
     */
    200: DownloadCompliancePackageResponseContent;
};

export type DownloadCompliancePackageResponse = DownloadCompliancePackageResponses[keyof DownloadCompliancePackageResponses];

export type GetCustomerSettingsData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/customer_settings';
};

export type GetCustomerSettingsResponses = {
    /**
     * GetCustomerSettings 200 response
     */
    200: GetCustomerSettingsResponseContent;
};

export type GetCustomerSettingsResponse = GetCustomerSettingsResponses[keyof GetCustomerSettingsResponses];

export type PatchCustomerSettingsData = {
    body?: PatchCustomerSettingsRequestContent;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/customer_settings';
};

export type PatchCustomerSettingsResponses = {
    /**
     * PatchCustomerSettings 200 response
     */
    200: PatchCustomerSettingsResponseContent;
};

export type PatchCustomerSettingsResponse = PatchCustomerSettingsResponses[keyof PatchCustomerSettingsResponses];

export type GetCustomersData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
    };
    path?: never;
    query?: {
        /**
         * Current status
         */
        status?: CustomerStatus;
        /**
         * Country ISO Code
         */
        country_code?: CountryIsoCode;
        /**
         * Customer Type
         */
        customer_type?: CustomerType;
        /**
         * Business Registration Type
         */
        business_registration_type?: IndiaBusinessRegistrationType;
        /**
         * Representation of user specific filtering required or not
         */
        mine?: boolean;
        /**
         * Business name
         */
        business_name?: string;
    };
    url: '/api/v1/customers';
};

export type GetCustomersErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type GetCustomersError = GetCustomersErrors[keyof GetCustomersErrors];

export type GetCustomersResponses = {
    /**
     * GetCustomers 200 response
     */
    200: GetCustomersResponseContent;
};

export type GetCustomersResponse = GetCustomersResponses[keyof GetCustomersResponses];

export type PatchCustomerData = {
    body: PatchCustomerRequestContent;
    headers: {
        'X-Organization-ID': string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/customers';
};

export type PatchCustomerResponses = {
    /**
     * PatchCustomer 200 response
     */
    200: PatchCustomerResponseContent;
};

export type PatchCustomerResponse = PatchCustomerResponses[keyof PatchCustomerResponses];

export type CreateCustomerData = {
    body?: CreateCustomerRequestContent;
    headers: {
        'X-Organization-ID': string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/customers';
};

export type CreateCustomerErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type CreateCustomerError = CreateCustomerErrors[keyof CreateCustomerErrors];

export type CreateCustomerResponses = {
    /**
     * CreateCustomer 200 response
     */
    200: CreateCustomerResponseContent;
};

export type CreateCustomerResponse = CreateCustomerResponses[keyof CreateCustomerResponses];

export type GetCustomerByIdData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
    };
    path: {
        /**
         * Customer ID
         */
        id: string;
    };
    query?: never;
    url: '/api/v1/customers/{id}';
};

export type GetCustomerByIdErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type GetCustomerByIdError = GetCustomerByIdErrors[keyof GetCustomerByIdErrors];

export type GetCustomerByIdResponses = {
    /**
     * GetCustomerById 200 response
     */
    200: GetCustomerByIdResponseContent;
};

export type GetCustomerByIdResponse = GetCustomerByIdResponses[keyof GetCustomerByIdResponses];

export type GetDepositsData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/deposits';
};

export type GetDepositsErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type GetDepositsError = GetDepositsErrors[keyof GetDepositsErrors];

export type GetDepositsResponses = {
    /**
     * GetDeposits 200 response
     */
    200: GetDepositsResponseContent;
};

export type GetDepositsResponse = GetDepositsResponses[keyof GetDepositsResponses];

export type PatchDepositData = {
    body?: PatchDepositRequestContent;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path: {
        /**
         * Deposit Id
         */
        deposit_id: string;
    };
    query?: never;
    url: '/api/v1/deposits/{deposit_id}';
};

export type PatchDepositErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type PatchDepositError = PatchDepositErrors[keyof PatchDepositErrors];

export type PatchDepositResponses = {
    /**
     * PatchDeposit 200 response
     */
    200: PatchDepositResponseContent;
};

export type PatchDepositResponse = PatchDepositResponses[keyof PatchDepositResponses];

export type GetFeesData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query: {
        /**
         * USD amount
         */
        sell_amount: number;
        /**
         * For now value should be USD
         */
        sell_currency: Currency;
        /**
         * For now value should be INR
         */
        buy_currency: Currency;
    };
    url: '/api/v1/fees';
};

export type GetFeesResponses = {
    /**
     * GetFees 200 response
     */
    200: GetFeesResponseContent;
};

export type GetFeesResponse = GetFeesResponses[keyof GetFeesResponses];

export type GetFilesByCustomerIdData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/files';
};

export type GetFilesByCustomerIdResponses = {
    /**
     * GetFilesByCustomerId 200 response
     */
    200: GetFilesByCustomerIdResponseContent;
};

export type GetFilesByCustomerIdResponse = GetFilesByCustomerIdResponses[keyof GetFilesByCustomerIdResponses];

export type UploadFileData = {
    body: UploadFileInputPayload;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query: {
        /**
         * File name
         */
        file_name: string;
        /**
         * File Size
         */
        size: number;
        /**
         * File purpose
         */
        purpose: Purpose;
        /**
         * Mime type
         */
        mime_type: MimeType;
    };
    url: '/api/v1/files';
};

export type UploadFileResponses = {
    /**
     * UploadFile 200 response
     */
    200: UploadFileResponseContent;
};

export type UploadFileResponse = UploadFileResponses[keyof UploadFileResponses];

export type GenerateHdfcIrmReportData = {
    body: GenerateHdfcIrmReportRequestContent;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/files/hdfc-irm';
};

export type GenerateHdfcIrmReportResponses = {
    /**
     * GenerateHdfcIrmReport 200 response
     */
    200: GenerateHdfcIrmReportOutputPayload;
};

export type GenerateHdfcIrmReportResponse = GenerateHdfcIrmReportResponses[keyof GenerateHdfcIrmReportResponses];

export type GenerateHdfcRequestLetterData = {
    body: GenerateHdfcRequestLetterRequestContent;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/files/hdfc-letter';
};

export type GenerateHdfcRequestLetterResponses = {
    /**
     * GenerateHdfcRequestLetter 200 response
     */
    200: GenerateHdfcRequestLetterOutputPayload;
};

export type GenerateHdfcRequestLetterResponse = GenerateHdfcRequestLetterResponses[keyof GenerateHdfcRequestLetterResponses];

export type CreateInvoicePreviewData = {
    body: CreateInvoicePreviewRequestContent;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/files/invoice-preview';
};

export type CreateInvoicePreviewResponses = {
    /**
     * CreateInvoicePreview 200 response
     */
    200: CreateInvoicePreviewOutputPayload;
};

export type CreateInvoicePreviewResponse = CreateInvoicePreviewResponses[keyof CreateInvoicePreviewResponses];

export type DeleteFileByIdData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
    };
    path: {
        /**
         * File Id
         */
        file_id: string;
    };
    query?: never;
    url: '/api/v1/files/{file_id}';
};

export type DeleteFileByIdErrors = {
    /**
     * BadRequestError 400 response
     */
    400: BadRequestErrorResponseContent;
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * ResourceNotFoundError 404 response
     */
    404: ResourceNotFoundErrorResponseContent;
};

export type DeleteFileByIdError = DeleteFileByIdErrors[keyof DeleteFileByIdErrors];

export type DeleteFileByIdResponses = {
    /**
     * DeleteFileById 200 response
     */
    200: DeleteFileByIdResponseContent;
};

export type DeleteFileByIdResponse = DeleteFileByIdResponses[keyof DeleteFileByIdResponses];

export type GetFileByIdData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path: {
        /**
         * File Id
         */
        file_id: string;
    };
    query: {
        /**
         * purpose
         */
        purpose: Purpose;
    };
    url: '/api/v1/files/{file_id}';
};

export type GetFileByIdResponses = {
    /**
     * GetFileById 200 response
     */
    200: GetFileByIdResponseContent;
};

export type GetFileByIdResponse = GetFileByIdResponses[keyof GetFileByIdResponses];

export type GetFileContentByIdData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path: {
        /**
         * File Id
         */
        file_id: string;
    };
    query: {
        /**
         * purpose
         */
        purpose: Purpose;
    };
    url: '/api/v1/files/{file_id}/content';
};

export type GetFileContentByIdResponses = {
    /**
     * GetFileContentById 200 response
     */
    200: GetFileContentByIdOutputPayload;
};

export type GetFileContentByIdResponse = GetFileContentByIdResponses[keyof GetFileContentByIdResponses];

export type GetIdentityVerificationsData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/identity_verifications';
};

export type GetIdentityVerificationsResponses = {
    /**
     * GetIdentityVerifications 200 response
     */
    200: GetIdentityVerificationsResponseContent;
};

export type GetIdentityVerificationsResponse = GetIdentityVerificationsResponses[keyof GetIdentityVerificationsResponses];

export type PostIdentityVerificationData = {
    body: PostIdentityVerificationRequestContent;
    headers: {
        'X-Organization-ID': string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/identity_verifications';
};

export type PostIdentityVerificationResponses = {
    /**
     * PostIdentityVerification 201 response
     */
    201: PostIdentityVerificationResponseContent;
};

export type PostIdentityVerificationResponse = PostIdentityVerificationResponses[keyof PostIdentityVerificationResponses];

export type PatchIdentityVerificationQueryDocumentsData = {
    body: PatchIdentityVerificationQueryDocumentsRequestContent;
    headers: {
        'X-Organization-ID': string;
    };
    path: {
        verification_id: string;
    };
    query?: never;
    url: '/api/v1/identity_verifications/queries/{verification_id}/';
};

export type PatchIdentityVerificationQueryDocumentsResponses = {
    /**
     * PatchIdentityVerificationQueryDocuments 200 response
     */
    200: PatchIdentityVerificationQueryDocumentsResponseContent;
};

export type PatchIdentityVerificationQueryDocumentsResponse = PatchIdentityVerificationQueryDocumentsResponses[keyof PatchIdentityVerificationQueryDocumentsResponses];

export type GetIdentityVerificationDetailsByIdData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
    };
    path: {
        verification_id: string;
    };
    query?: never;
    url: '/api/v1/identity_verifications/{verification_id}';
};

export type GetIdentityVerificationDetailsByIdResponses = {
    /**
     * GetIdentityVerificationDetailsById 200 response
     */
    200: GetIdentityVerificationDetailsByIdResponseContent;
};

export type GetIdentityVerificationDetailsByIdResponse = GetIdentityVerificationDetailsByIdResponses[keyof GetIdentityVerificationDetailsByIdResponses];

export type PatchVerificationFlowSubmissionData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        'X-User-Agent': string;
        'X-User-Ip': string;
    };
    path: {
        verification_id: string;
    };
    query?: never;
    url: '/api/v1/identity_verifications/{verification_id}';
};

export type PatchVerificationFlowSubmissionResponses = {
    /**
     * PatchVerificationFlowSubmission 200 response
     */
    200: PatchVerificationFlowSubmissionResponseContent;
};

export type PatchVerificationFlowSubmissionResponse = PatchVerificationFlowSubmissionResponses[keyof PatchVerificationFlowSubmissionResponses];

export type PatchVerificationStepDataData = {
    body: PatchVerificationStepDataRequestContent;
    headers: {
        'X-Organization-ID': string;
    };
    path: {
        verification_id: string;
        step_id: VerificationStepName;
    };
    query?: never;
    url: '/api/v1/identity_verifications/{verification_id}/steps/{step_id}';
};

export type PatchVerificationStepDataResponses = {
    /**
     * PatchVerificationStepData 200 response
     */
    200: PatchVerificationStepDataResponseContent;
};

export type PatchVerificationStepDataResponse = PatchVerificationStepDataResponses[keyof PatchVerificationStepDataResponses];

export type GetInvoicesData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * Owning customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: {
        /**
         * PartnerIds
         */
        partner_ids?: Array<string>;
    };
    url: '/api/v1/invoices';
};

export type GetInvoicesResponses = {
    /**
     * GetInvoices 200 response
     */
    200: GetInvoicesResponseContent;
};

export type GetInvoicesResponse = GetInvoicesResponses[keyof GetInvoicesResponses];

export type CreateInvoiceData = {
    body: CreateInvoiceRequestContent;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/invoices';
};

export type CreateInvoiceErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type CreateInvoiceError = CreateInvoiceErrors[keyof CreateInvoiceErrors];

export type CreateInvoiceResponses = {
    /**
     * CreateInvoice 200 response
     */
    200: CreateInvoiceResponseContent;
};

export type CreateInvoiceResponse = CreateInvoiceResponses[keyof CreateInvoiceResponses];

export type PostInvoiceOverdueReminderData = {
    body?: PostInvoiceOverdueReminderRequestContent;
    headers: {
        'X-Organization-ID': string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/invoices/overdue-reminder';
};

export type PostInvoiceOverdueReminderErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type PostInvoiceOverdueReminderError = PostInvoiceOverdueReminderErrors[keyof PostInvoiceOverdueReminderErrors];

export type PostInvoiceOverdueReminderResponses = {
    /**
     * PostInvoiceOverdueReminder 200 response
     */
    200: PostInvoiceOverdueReminderResponseContent;
};

export type PostInvoiceOverdueReminderResponse = PostInvoiceOverdueReminderResponses[keyof PostInvoiceOverdueReminderResponses];

export type GetInvoiceByPayoutIdData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * Customer id
         */
        customer_id: string;
    };
    path: {
        /**
         * Payout ID
         */
        payout_id: string;
    };
    query?: never;
    url: '/api/v1/invoices/payout/{payout_id}';
};

export type GetInvoiceByPayoutIdErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type GetInvoiceByPayoutIdError = GetInvoiceByPayoutIdErrors[keyof GetInvoiceByPayoutIdErrors];

export type GetInvoiceByPayoutIdResponses = {
    /**
     * GetInvoiceByPayoutId 200 response
     */
    200: GetInvoiceByPayoutIdResponseContent;
};

export type GetInvoiceByPayoutIdResponse = GetInvoiceByPayoutIdResponses[keyof GetInvoiceByPayoutIdResponses];

export type GetInvoiceByIdData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
    };
    path: {
        /**
         * Invoice ID
         */
        invoice_id: string;
    };
    query?: never;
    url: '/api/v1/invoices/{invoice_id}';
};

export type GetInvoiceByIdErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type GetInvoiceByIdError = GetInvoiceByIdErrors[keyof GetInvoiceByIdErrors];

export type GetInvoiceByIdResponses = {
    /**
     * GetInvoiceById 200 response
     */
    200: GetInvoiceByIdResponseContent;
};

export type GetInvoiceByIdResponse = GetInvoiceByIdResponses[keyof GetInvoiceByIdResponses];

export type UpdateInvoiceByIdData = {
    body: UpdateInvoiceByIdRequestContent;
    headers: {
        'X-Organization-ID': string;
    };
    path: {
        /**
         * Invoice ID
         */
        invoice_id: string;
    };
    query?: never;
    url: '/api/v1/invoices/{invoice_id}';
};

export type UpdateInvoiceByIdErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type UpdateInvoiceByIdError = UpdateInvoiceByIdErrors[keyof UpdateInvoiceByIdErrors];

export type UpdateInvoiceByIdResponses = {
    /**
     * UpdateInvoiceById 200 response
     */
    200: UpdateInvoiceByIdResponseContent;
};

export type UpdateInvoiceByIdResponse = UpdateInvoiceByIdResponses[keyof UpdateInvoiceByIdResponses];

export type PostMultiCurrencyEnableData = {
    body?: PostMultiCurrencyEnableRequestContent;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/multi_currency';
};

export type PostMultiCurrencyEnableErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type PostMultiCurrencyEnableError = PostMultiCurrencyEnableErrors[keyof PostMultiCurrencyEnableErrors];

export type PostMultiCurrencyEnableResponses = {
    /**
     * PostMultiCurrencyEnable 200 response
     */
    200: PostMultiCurrencyEnableResponseContent;
};

export type PostMultiCurrencyEnableResponse = PostMultiCurrencyEnableResponses[keyof PostMultiCurrencyEnableResponses];

export type GetCurrencyWalletsData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/multi_currency/currency_wallet';
};

export type GetCurrencyWalletsResponses = {
    /**
     * GetCurrencyWallets 200 response
     */
    200: GetCurrencyWalletsResponseContent;
};

export type GetCurrencyWalletsResponse = GetCurrencyWalletsResponses[keyof GetCurrencyWalletsResponses];

export type PostCurrencyWalletData = {
    body: PostCurrencyWalletRequestContent;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/multi_currency/currency_wallet';
};

export type PostCurrencyWalletResponses = {
    /**
     * PostCurrencyWallet 200 response
     */
    200: PostCurrencyWalletResponseContent;
};

export type PostCurrencyWalletResponse = PostCurrencyWalletResponses[keyof PostCurrencyWalletResponses];

export type GetBeneficialOwnersData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/multi_currency/owners';
};

export type GetBeneficialOwnersResponses = {
    /**
     * GetBeneficialOwners 200 response
     */
    200: GetBeneficialOwnersResponseContent;
};

export type GetBeneficialOwnersResponse = GetBeneficialOwnersResponses[keyof GetBeneficialOwnersResponses];

export type PostBeneficialOwnerData = {
    body: PostBeneficialOwnerRequestContent;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/multi_currency/owners';
};

export type PostBeneficialOwnerResponses = {
    /**
     * PostBeneficialOwner 200 response
     */
    200: PostBeneficialOwnerResponseContent;
};

export type PostBeneficialOwnerResponse = PostBeneficialOwnerResponses[keyof PostBeneficialOwnerResponses];

export type DeleteBeneficialOwnerData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path: {
        /**
         * Beneficial owner id
         */
        owner_id: string;
    };
    query?: never;
    url: '/api/v1/multi_currency/owners/{owner_id}';
};

export type DeleteBeneficialOwnerResponses = {
    /**
     * DeleteBeneficialOwner 200 response
     */
    200: DeleteBeneficialOwnerResponseContent;
};

export type DeleteBeneficialOwnerResponse = DeleteBeneficialOwnerResponses[keyof DeleteBeneficialOwnerResponses];

export type PatchBeneficialOwnerData = {
    body: PatchBeneficialOwnerRequestContent;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path: {
        /**
         * Beneficial owner id
         */
        owner_id: string;
    };
    query?: never;
    url: '/api/v1/multi_currency/owners/{owner_id}';
};

export type PatchBeneficialOwnerErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type PatchBeneficialOwnerError = PatchBeneficialOwnerErrors[keyof PatchBeneficialOwnerErrors];

export type PatchBeneficialOwnerResponses = {
    /**
     * PatchBeneficialOwner 200 response
     */
    200: PatchBeneficialOwnerResponseContent;
};

export type PatchBeneficialOwnerResponse = PatchBeneficialOwnerResponses[keyof PatchBeneficialOwnerResponses];

export type GetPartnersData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
    };
    path?: never;
    query?: {
        /**
         * customer id
         */
        owning_customer_id?: string;
        /**
         * customer id
         */
        associative_customer_id?: string;
    };
    url: '/api/v1/partners';
};

export type GetPartnersErrors = {
    /**
     * BadRequestError 400 response
     */
    400: BadRequestErrorResponseContent;
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * ResourceNotFoundError 404 response
     */
    404: ResourceNotFoundErrorResponseContent;
};

export type GetPartnersError = GetPartnersErrors[keyof GetPartnersErrors];

export type GetPartnersResponses = {
    /**
     * GetPartners 200 response
     */
    200: GetPartnersResponseContent;
};

export type GetPartnersResponse = GetPartnersResponses[keyof GetPartnersResponses];

export type CreatePartnerData = {
    body?: CreatePartnerRequestContent;
    headers: {
        'X-Organization-ID': string;
        /**
         * Owning customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/partners';
};

export type CreatePartnerErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type CreatePartnerError = CreatePartnerErrors[keyof CreatePartnerErrors];

export type CreatePartnerResponses = {
    /**
     * CreatePartner 200 response
     */
    200: CreatePartnerResponseContent;
};

export type CreatePartnerResponse = CreatePartnerResponses[keyof CreatePartnerResponses];

export type GetPartnerByIdData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
    };
    path: {
        /**
         * Partner ID
         */
        id: string;
    };
    query?: never;
    url: '/api/v1/partners/{id}';
};

export type GetPartnerByIdResponses = {
    /**
     * GetPartnerById 200 response
     */
    200: GetPartnerByIdResponseContent;
};

export type GetPartnerByIdResponse = GetPartnerByIdResponses[keyof GetPartnerByIdResponses];

export type UpdatePartnerData = {
    body: UpdatePartnerRequestContent;
    headers: {
        'X-Organization-ID': string;
        /**
         * Owning customer id
         */
        customer_id: string;
    };
    path: {
        /**
         * id
         */
        id: string;
    };
    query?: never;
    url: '/api/v1/partners/{id}';
};

export type UpdatePartnerErrors = {
    /**
     * BadRequestError 400 response
     */
    400: BadRequestErrorResponseContent;
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * ResourceNotFoundError 404 response
     */
    404: ResourceNotFoundErrorResponseContent;
};

export type UpdatePartnerError = UpdatePartnerErrors[keyof UpdatePartnerErrors];

export type UpdatePartnerResponses = {
    /**
     * UpdatePartner 200 response
     */
    200: UpdatePartnerResponseContent;
};

export type UpdatePartnerResponse = UpdatePartnerResponses[keyof UpdatePartnerResponses];

export type GetPayoutsData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: {
        /**
         * Need the time in the secs
         */
        from_time?: number;
        /**
         * Need the time in the secs
         */
        to_time?: number;
    };
    url: '/api/v1/payouts';
};

export type GetPayoutsResponses = {
    /**
     * GetPayouts 200 response
     */
    200: GetPayoutsResponseContent;
};

export type GetPayoutsResponse = GetPayoutsResponses[keyof GetPayoutsResponses];

export type PostPayoutsData = {
    body?: PostPayoutsRequestContent;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/payouts';
};

export type PostPayoutsErrors = {
    /**
     * UnprocessableEntityError 422 response
     */
    422: UnprocessableEntityErrorResponseContent;
};

export type PostPayoutsError = PostPayoutsErrors[keyof PostPayoutsErrors];

export type PostPayoutsResponses = {
    /**
     * PostPayouts 200 response
     */
    200: PostPayoutsResponseContent;
};

export type PostPayoutsResponse = PostPayoutsResponses[keyof PostPayoutsResponses];

export type PostPayoutsPreviewData = {
    body: PostPayoutsPreviewRequestContent;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/payouts/preview';
};

export type PostPayoutsPreviewResponses = {
    /**
     * PostPayoutsPreview 200 response
     */
    200: PostPayoutsPreviewResponseContent;
};

export type PostPayoutsPreviewResponse = PostPayoutsPreviewResponses[keyof PostPayoutsPreviewResponses];

export type GenerateBankDetailsPdfData = {
    body: GenerateBankDetailsPdfRequestContent;
    path?: never;
    query?: never;
    url: '/api/v1/public/bank-details/pdf';
};

export type GenerateBankDetailsPdfErrors = {
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type GenerateBankDetailsPdfError = GenerateBankDetailsPdfErrors[keyof GenerateBankDetailsPdfErrors];

export type GenerateBankDetailsPdfResponses = {
    /**
     * GenerateBankDetailsPDF 200 response
     */
    200: GenerateBankDetailsPdfOutputPayload;
};

export type GenerateBankDetailsPdfResponse = GenerateBankDetailsPdfResponses[keyof GenerateBankDetailsPdfResponses];

export type PostContactFormData = {
    body: PostContactFormRequestContent;
    path?: never;
    query?: never;
    url: '/api/v1/public/contact';
};

export type PostContactFormErrors = {
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type PostContactFormError = PostContactFormErrors[keyof PostContactFormErrors];

export type PostContactFormResponses = {
    /**
     * PostContactForm 200 response
     */
    200: PostContactFormResponseContent;
};

export type PostContactFormResponse = PostContactFormResponses[keyof PostContactFormResponses];

export type GetGenericFeesData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
    };
    path?: never;
    query: {
        /**
         * For now value should be USD
         */
        sell_currency: Currency;
        /**
         * For now value should be INR
         */
        buy_currency: Currency;
    };
    url: '/api/v1/public/fees';
};

export type GetGenericFeesErrors = {
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type GetGenericFeesError = GetGenericFeesErrors[keyof GetGenericFeesErrors];

export type GetGenericFeesResponses = {
    /**
     * GetGenericFees 200 response
     */
    200: GetGenericFeesResponseContent;
};

export type GetGenericFeesResponse = GetGenericFeesResponses[keyof GetGenericFeesResponses];

export type GetCostsFromFircData = {
    body: GetCostsFromFircInputPayload;
    path?: never;
    query: {
        /**
         * File name
         */
        file_name: string;
    };
    url: '/api/v1/public/firc';
};

export type GetCostsFromFircErrors = {
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type GetCostsFromFircError = GetCostsFromFircErrors[keyof GetCostsFromFircErrors];

export type GetCostsFromFircResponses = {
    /**
     * GetCostsFromFirc 200 response
     */
    200: GetCostsFromFircResponseContent;
};

export type GetCostsFromFircResponse = GetCostsFromFircResponses[keyof GetCostsFromFircResponses];

export type GetFircUploadResponseByIdData = {
    body?: never;
    path: {
        /**
         * Unique identifier of XflowFircUploadResponse
         */
        id: string;
    };
    query?: never;
    url: '/api/v1/public/firc/{id}';
};

export type GetFircUploadResponseByIdErrors = {
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type GetFircUploadResponseByIdError = GetFircUploadResponseByIdErrors[keyof GetFircUploadResponseByIdErrors];

export type GetFircUploadResponseByIdResponses = {
    /**
     * GetFircUploadResponseById 200 response
     */
    200: GetFircUploadResponseByIdResponseContent;
};

export type GetFircUploadResponseByIdResponse = GetFircUploadResponseByIdResponses[keyof GetFircUploadResponseByIdResponses];

export type GetEmailUnsubscribeStatusData = {
    body?: never;
    path: {
        hash: string;
    };
    query?: never;
    url: '/api/v1/public/unsubscribe/{hash}';
};

export type GetEmailUnsubscribeStatusErrors = {
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type GetEmailUnsubscribeStatusError = GetEmailUnsubscribeStatusErrors[keyof GetEmailUnsubscribeStatusErrors];

export type GetEmailUnsubscribeStatusResponses = {
    /**
     * GetEmailUnsubscribeStatus 200 response
     */
    200: GetEmailUnsubscribeStatusResponseContent;
};

export type GetEmailUnsubscribeStatusResponse = GetEmailUnsubscribeStatusResponses[keyof GetEmailUnsubscribeStatusResponses];

export type PostEmailUnsubscribeData = {
    body: PostEmailUnsubscribeRequestContent;
    path: {
        hash: string;
    };
    query?: never;
    url: '/api/v1/public/unsubscribe/{hash}';
};

export type PostEmailUnsubscribeErrors = {
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type PostEmailUnsubscribeError = PostEmailUnsubscribeErrors[keyof PostEmailUnsubscribeErrors];

export type PostEmailUnsubscribeResponses = {
    /**
     * PostEmailUnsubscribe 200 response
     */
    200: PostEmailUnsubscribeResponseContent;
};

export type PostEmailUnsubscribeResponse = PostEmailUnsubscribeResponses[keyof PostEmailUnsubscribeResponses];

export type GetPurposeCodesData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * Customer ID
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/purpose_codes';
};

export type GetPurposeCodesErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type GetPurposeCodesError = GetPurposeCodesErrors[keyof GetPurposeCodesErrors];

export type GetPurposeCodesResponses = {
    /**
     * GetPurposeCodes 200 response
     */
    200: GetPurposeCodesResponseContent;
};

export type GetPurposeCodesResponse = GetPurposeCodesResponses[keyof GetPurposeCodesResponses];

export type PostPurposeCodesData = {
    body: PostPurposeCodesRequestContent;
    headers: {
        'X-Organization-ID': string;
        /**
         * Customer ID
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/purpose_codes';
};

export type PostPurposeCodesErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type PostPurposeCodesError = PostPurposeCodesErrors[keyof PostPurposeCodesErrors];

export type PostPurposeCodesResponses = {
    /**
     * PostPurposeCodes 200 response
     */
    200: PostPurposeCodesResponseContent;
};

export type PostPurposeCodesResponse = PostPurposeCodesResponses[keyof PostPurposeCodesResponses];

export type GetUsersData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/users';
};

export type GetUsersErrors = {
    /**
     * BadRequestError 400 response
     */
    400: BadRequestErrorResponseContent;
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * ResourceNotFoundError 404 response
     */
    404: ResourceNotFoundErrorResponseContent;
};

export type GetUsersError = GetUsersErrors[keyof GetUsersErrors];

export type GetUsersResponses = {
    /**
     * GetUsers 200 response
     */
    200: GetUsersResponseContent;
};

export type GetUsersResponse = GetUsersResponses[keyof GetUsersResponses];

export type PatchUserData = {
    body?: PatchUserRequestContent;
    headers: {
        'X-Organization-ID': string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/users';
};

export type PatchUserResponses = {
    /**
     * PatchUser 200 response
     */
    200: PatchUserResponseContent;
};

export type PatchUserResponse = PatchUserResponses[keyof PatchUserResponses];

export type GetOrCreateUserData = {
    body?: GetOrCreateUserRequestContent;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/users';
};

export type GetOrCreateUserErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type GetOrCreateUserError = GetOrCreateUserErrors[keyof GetOrCreateUserErrors];

export type GetOrCreateUserResponses = {
    /**
     * GetOrCreateUser 200 response
     */
    200: GetOrCreateUserResponseContent;
};

export type GetOrCreateUserResponse = GetOrCreateUserResponses[keyof GetOrCreateUserResponses];

export type GetUserByEmailData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
    };
    path?: never;
    query: {
        /**
         * Email address of the user
         */
        email: string;
    };
    url: '/api/v1/users/email';
};

export type GetUserByEmailErrors = {
    /**
     * BadRequestError 400 response
     */
    400: BadRequestErrorResponseContent;
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * ResourceNotFoundError 404 response
     */
    404: ResourceNotFoundErrorResponseContent;
};

export type GetUserByEmailError = GetUserByEmailErrors[keyof GetUserByEmailErrors];

export type GetUserByEmailResponses = {
    /**
     * GetUserByEmail 200 response
     */
    200: GetUserByEmailResponseContent;
};

export type GetUserByEmailResponse = GetUserByEmailResponses[keyof GetUserByEmailResponses];

export type SyncUserData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/users/sync';
};

export type SyncUserErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * ResourceNotFoundError 404 response
     */
    404: ResourceNotFoundErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type SyncUserError = SyncUserErrors[keyof SyncUserErrors];

export type SyncUserResponses = {
    /**
     * SyncUser 200 response
     */
    200: SyncUserResponseContent;
};

export type SyncUserResponse = SyncUserResponses[keyof SyncUserResponses];

export type DeleteUserData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
        /**
         * customer id
         */
        customer_id: string;
    };
    path: {
        /**
         * user_id
         */
        user_id: string;
    };
    query?: never;
    url: '/api/v1/users/{user_id}';
};

export type DeleteUserErrors = {
    /**
     * BadRequestError 400 response
     */
    400: BadRequestErrorResponseContent;
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * ResourceNotFoundError 404 response
     */
    404: ResourceNotFoundErrorResponseContent;
};

export type DeleteUserError = DeleteUserErrors[keyof DeleteUserErrors];

export type DeleteUserResponses = {
    /**
     * DeleteUser 200 response
     */
    200: DeleteUserResponseContent;
};

export type DeleteUserResponse = DeleteUserResponses[keyof DeleteUserResponses];

export type GetUserByIdData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
    };
    path: {
        /**
         * Unique identifier of the user
         */
        user_id: string;
    };
    query?: never;
    url: '/api/v1/users/{user_id}';
};

export type GetUserByIdErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * ResourceNotFoundError 404 response
     */
    404: ResourceNotFoundErrorResponseContent;
};

export type GetUserByIdError = GetUserByIdErrors[keyof GetUserByIdErrors];

export type GetUserByIdResponses = {
    /**
     * GetUserById 200 response
     */
    200: GetUserByIdResponseContent;
};

export type GetUserByIdResponse = GetUserByIdResponses[keyof GetUserByIdResponses];

export type GetNfcCardDetailsData = {
    body?: never;
    headers: {
        'X-Organization-ID': string;
    };
    path: {
        /**
         * User ID
         */
        user_id: string;
    };
    query?: never;
    url: '/api/v1/users/{user_id}/nfc-card';
};

export type GetNfcCardDetailsErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * ResourceNotFoundError 404 response
     */
    404: ResourceNotFoundErrorResponseContent;
};

export type GetNfcCardDetailsError = GetNfcCardDetailsErrors[keyof GetNfcCardDetailsErrors];

export type GetNfcCardDetailsResponses = {
    /**
     * GetNFCCardDetails 200 response
     */
    200: GetNfcCardDetailsResponseContent;
};

export type GetNfcCardDetailsResponse = GetNfcCardDetailsResponses[keyof GetNfcCardDetailsResponses];

export type CreateOrUpdateNfcCardData = {
    body: CreateOrUpdateNfcCardRequestContent;
    headers: {
        'X-Organization-ID': string;
    };
    path: {
        /**
         * User ID
         */
        user_id: string;
    };
    query?: never;
    url: '/api/v1/users/{user_id}/nfc-card';
};

export type CreateOrUpdateNfcCardErrors = {
    /**
     * AccessDeniedError 401 response
     */
    401: AccessDeniedErrorResponseContent;
    /**
     * ResourceNotFoundError 404 response
     */
    404: ResourceNotFoundErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type CreateOrUpdateNfcCardError = CreateOrUpdateNfcCardErrors[keyof CreateOrUpdateNfcCardErrors];

export type CreateOrUpdateNfcCardResponses = {
    /**
     * CreateOrUpdateNFCCard 200 response
     */
    200: CreateOrUpdateNfcCardResponseContent;
};

export type CreateOrUpdateNfcCardResponse = CreateOrUpdateNfcCardResponses[keyof CreateOrUpdateNfcCardResponses];

export type SendOtpData = {
    body: SendOtpRequestContent;
    headers: {
        'X-Organization-ID': string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/utility/verification/send_otp';
};

export type SendOtpResponses = {
    /**
     * SendOtp 200 response
     */
    200: SendOtpResponseContent;
};

export type SendOtpResponse = SendOtpResponses[keyof SendOtpResponses];

export type VerifyOtpData = {
    body: VerifyOtpRequestContent;
    headers: {
        'X-Organization-ID': string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/utility/verification/verify_otp';
};

export type VerifyOtpErrors = {
    /**
     * InvalidOtpError 400 response
     */
    400: InvalidOtpErrorResponseContent;
};

export type VerifyOtpError = VerifyOtpErrors[keyof VerifyOtpErrors];

export type VerifyOtpResponses = {
    /**
     * VerifyOtp 200 response
     */
    200: VerifyOtpResponseContent;
};

export type VerifyOtpResponse = VerifyOtpResponses[keyof VerifyOtpResponses];

export type PostXflowWebhookData = {
    body: PostXflowWebhookInputPayload;
    headers?: {
        'webhook-id'?: string;
        'webhook-signature'?: string;
        'webhook-timestamp'?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/webhooks/xflow';
};

export type PostXflowWebhookErrors = {
    /**
     * BadRequestError 400 response
     */
    400: BadRequestErrorResponseContent;
    /**
     * InternalError 500 response
     */
    500: InternalErrorResponseContent;
};

export type PostXflowWebhookError = PostXflowWebhookErrors[keyof PostXflowWebhookErrors];

export type PostXflowWebhookResponses = {
    /**
     * PostXflowWebhook 200 response
     */
    200: PostXflowWebhookResponseContent;
};

export type PostXflowWebhookResponse = PostXflowWebhookResponses[keyof PostXflowWebhookResponses];